import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    AccountUpdateInput,
    UpdateAccountCustomFieldValue as UpdateAccountCustomFieldValueMutation,
    UpdateAccountCustomFieldValueVariables,
} from 'nutshell-graphql-types';

import UPDATE_ACCOUNT_CUSTOM_FIELD_VALUE from '../mutations/update-account-custom-field-value.graphql';

export const useUpdateAccountCustomFieldValue = (): {
    updateAccountCustomFieldValue: (arg1: AccountUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateAccountCustomFieldValue, {loading, error}] = useMutation<
        UpdateAccountCustomFieldValueMutation,
        UpdateAccountCustomFieldValueVariables
    >(UPDATE_ACCOUNT_CUSTOM_FIELD_VALUE);

    return {
        updateAccountCustomFieldValue: (input: AccountUpdateInput) =>
            updateAccountCustomFieldValue({
                variables: {input},
                refetchQueries: ['GetTopCustomFields', 'GetWidgetCustomFields'],
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
